import { InputProps, NumberInput } from 'react-admin';

interface NumberRangeFilterInputProps extends InputProps {

}

const NumberRangeFilterInput = ({ source }: NumberRangeFilterInputProps) => {
  return (
    <>
      <NumberInput source={`${source}.ge`} />
      <NumberInput source={`${source}.le`} />
    </>
  );
};
export default NumberRangeFilterInput;
